<template>
  <div>
    <form action="" @submit.prevent="update" id="profile-form">
      <div class="columns is-centered" v-if="tab == 0">
        <div class="column">
          <div class="box is-boxed-3">
            <div class="columns">
              <div class="column" v-if="isEmpty(auth.email)">
                <div class="columns is-mobile is-vcentered">
                  <div class="column">
                    <h1 class="title font-16 has-text-darkblue font-w-600">Pengaturan Data Diri</h1>
                  </div>
                </div>

                <div class="columns">
                  <div class="column">
                    <form action="" id="profile-form">
                      <div class="columns">
                        <div class="column">
                          <div class="">
                            <div class="field">
                              <label class="label has-text-primary2 font-w-500 font-14">Nama Lengkap<span class="has-text-danger">*</span></label>
                              <p class="control is-expanded has-icons-left has-text-darkblue">
                                <input class="input has-text-darkblue font-w-500" type="text" placeholder="Nama Lengkap" name="name" v-model="user.name"/>
                                <span class="icon is-small is-left">
                                  <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg" style="width: 1rem; height: 1rem;">
                                    <path d="M11.7779 9.59169C12.5949 8.94891 13.1913 8.06746 13.484 7.06997C13.7767 6.07249 13.7512 5.00858 13.4111 4.02625C13.071 3.04391 12.4332 2.19202 11.5863 1.58907C10.7395 0.986122 9.72582 0.662109 8.68628 0.662109C7.64673 0.662109 6.63304 0.986122 5.78622 1.58907C4.9394 2.19202 4.30156 3.04391 3.96145 4.02625C3.62134 5.00858 3.59587 6.07249 3.88858 7.06997C4.18128 8.06746 4.77762 8.94891 5.59461 9.59169C4.19467 10.1526 2.97318 11.0828 2.06035 12.2833C1.14752 13.4838 0.577579 14.9094 0.411277 16.4084C0.399239 16.5178 0.408874 16.6285 0.439631 16.7342C0.470388 16.8399 0.521666 16.9386 0.590536 17.0245C0.729626 17.1979 0.93193 17.309 1.15294 17.3334C1.37396 17.3577 1.59558 17.2932 1.76905 17.1541C1.94252 17.015 2.05363 16.8127 2.07794 16.5917C2.26093 14.9627 3.03768 13.4582 4.25979 12.3657C5.4819 11.2732 7.06369 10.6692 8.70294 10.6692C10.3422 10.6692 11.924 11.2732 13.1461 12.3657C14.3682 13.4582 15.145 14.9627 15.3279 16.5917C15.3506 16.7965 15.4483 16.9856 15.6022 17.1225C15.7561 17.2595 15.9553 17.3346 16.1613 17.3334H16.2529C16.4714 17.3082 16.671 17.1978 16.8084 17.0261C16.9458 16.8544 17.0097 16.6353 16.9863 16.4167C16.8192 14.9135 16.2462 13.4842 15.3287 12.2819C14.4111 11.0795 13.1837 10.1496 11.7779 9.59169ZM8.68628 9.00002C8.02701 9.00002 7.38254 8.80453 6.83438 8.43825C6.28621 8.07198 5.85897 7.55139 5.60668 6.9423C5.35439 6.33321 5.28837 5.66299 5.41699 5.01639C5.54561 4.36979 5.86308 3.77584 6.32925 3.30967C6.79543 2.84349 7.38937 2.52602 8.03598 2.39741C8.68258 2.26879 9.3528 2.3348 9.96189 2.58709C10.571 2.83938 11.0916 3.26662 11.4578 3.81479C11.8241 4.36295 12.0196 5.00742 12.0196 5.66669C12.0196 6.55074 11.6684 7.39859 11.0433 8.02371C10.4182 8.64883 9.57033 9.00002 8.68628 9.00002Z" fill="#7985CB"/>
                                    </svg>

                                </span>
                              </p>
                            </div>

                            <div class="field">
                              <label class="label has-text-primary2 font-w-500 font-14">Email<span class="has-text-danger">*</span></label>
                              <div class="field is-grouped">
                                <p class="control is-expanded has-icons-left">
                                  <input class="input has-text-darkblue font-w-500" type="text" placeholder="Email" name="email" v-model="user.email"/>
                                  <span class="icon is-small is-left">
                                    <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg" style="width: 1rem; height: 1rem;">
                                      <path d="M14.5196 0.333008H2.85294C2.18989 0.333008 1.55401 0.5964 1.08517 1.06524C0.616328 1.53408 0.352936 2.16997 0.352936 2.83301V11.1663C0.352936 11.8294 0.616328 12.4653 1.08517 12.9341C1.55401 13.4029 2.18989 13.6663 2.85294 13.6663H14.5196C15.1826 13.6663 15.8185 13.4029 16.2874 12.9341C16.7562 12.4653 17.0196 11.8294 17.0196 11.1663V2.83301C17.0196 2.16997 16.7562 1.53408 16.2874 1.06524C15.8185 0.5964 15.1826 0.333008 14.5196 0.333008ZM14.1779 1.99967L9.27794 6.89967C9.20047 6.97778 9.1083 7.03978 9.00675 7.08208C8.9052 7.12439 8.79628 7.14617 8.68627 7.14617C8.57626 7.14617 8.46734 7.12439 8.36579 7.08208C8.26424 7.03978 8.17207 6.97778 8.0946 6.89967L3.1946 1.99967H14.1779ZM15.3529 11.1663C15.3529 11.3874 15.2651 11.5993 15.1089 11.7556C14.9526 11.9119 14.7406 11.9997 14.5196 11.9997H2.85294C2.63192 11.9997 2.41996 11.9119 2.26368 11.7556C2.1074 11.5993 2.0196 11.3874 2.0196 11.1663V3.17467L6.9196 8.07467C7.38835 8.54284 8.02377 8.80581 8.68627 8.80581C9.34877 8.80581 9.98419 8.54284 10.4529 8.07467L15.3529 3.17467V11.1663Z" fill="#7985CB"/>
                                      </svg>

                                  </span>
                                </p>
                                <p class="control">
                                  <a class="button is-primary" @click.prevent="() => getVerificationCode(user.email, true)" :class="{'is-loading': loading_get_verification_code}" :disabled="loading_get_verification_code">
                                    <span class="icon">
                                      <i class="fas fa-paper-plane"></i>
                                    </span>
                                    <span>
                                      Kirim Kode
                                    </span>
                                  </a>
                                </p>
                              </div>
                            </div>

                            <div class="field">
                              <label class="label has-text-primary2 font-w-500 font-14">Masukkan kode verifikasi<span class="has-text-danger">*</span></label>
                              <p class="control is-expanded has-icons-left">
                                <input class="input has-text-darkblue font-w-500" type="text" placeholder="Kode" name="confirmation_code" v-model="user.confirmation_code" maxlength="5"/>
                                <span class="icon is-small is-left">
                                  <i class="uil uil-key-skeleton has-text-primary2"></i>
                                </span>
                              </p>
                            </div>

                            <div class="field">
                              <label class="label has-text-primary2 font-w-500 font-14">No. Handphone</label>
                              <p class="control is-expanded has-icons-left">
                                <b-input placeholder="No. Handphone"
                                  type="number"
                                  name="phone"
                                  min="0"
                                  v-model="user.phone"
                                  class="has-text-darkblue font-w-500"
                                >
                                </b-input>
                                <span class="icon is-small is-left">
                                  <i class="fa fa-phone has-text-primary2"></i>
                                </span>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <div class="column" v-if="user.setPasswordNeeded === true">
                <div class="columns is-mobile is-vcentered">
                  <div class="column">
                    <h1 class="title font-16 has-text-darkblue font-w-600">Pengaturan Kata Sandi</h1>
                  </div>
                </div>

                <div class="columns">
                  <div class="column">
                    <form action="" @submit.prevent="updatePassword" id="password-form">
                      <div class="">
                        <div class="field">
                          <label class="label has-text-primary2 font-w-500 font-14">Kata Sandi<span class="has-text-danger">*</span></label>
                          <p class="control is-expanded has-icons-left">
                            <input class="input has-text-darkblue font-w-500 " type="password" placeholder="Kata Sandi" name="password" v-model="dataPassword.password"/>
                            <span class="icon is-small is-left">
                              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" style="width: 1rem; height: 1rem;">
                                <path d="M16.5 2.67483L17.0916 2.0915C17.2485 1.93458 17.3367 1.72175 17.3367 1.49983C17.3367 1.27791 17.2485 1.06508 17.0916 0.908162C16.9347 0.751243 16.7219 0.663086 16.5 0.663086C16.278 0.663086 16.0652 0.751243 15.9083 0.908162L14.7416 2.08316L12.3833 4.4415L7.12496 9.6915C6.26332 9.12303 5.22135 8.89463 4.20093 9.05057C3.18051 9.20651 2.25431 9.73568 1.60178 10.5355C0.949253 11.3354 0.616865 12.349 0.669022 13.3799C0.721179 14.4109 1.15417 15.3858 1.88409 16.1157C2.61401 16.8456 3.58889 17.2786 4.61984 17.3308C5.65078 17.3829 6.66439 17.0505 7.46425 16.398C8.26411 15.7455 8.79328 14.8193 8.94922 13.7989C9.10515 12.7784 8.87676 11.7365 8.30829 10.8748L12.9666 6.20816L14.7333 7.98316C14.811 8.06031 14.9031 8.12141 15.0044 8.16295C15.1057 8.2045 15.2142 8.22568 15.3237 8.22529C15.4332 8.22491 15.5416 8.20296 15.6426 8.1607C15.7436 8.11844 15.8353 8.05669 15.9125 7.979C15.9896 7.9013 16.0507 7.80916 16.0922 7.70785C16.1338 7.60654 16.155 7.49804 16.1546 7.38855C16.1542 7.27905 16.1322 7.17071 16.09 7.06969C16.0477 6.96868 15.986 6.87698 15.9083 6.79983L14.1416 5.03316L15.325 3.85816L15.9083 4.4415C15.9854 4.51919 16.0771 4.58094 16.1782 4.6232C16.2792 4.66546 16.3875 4.68741 16.497 4.68779C16.6065 4.68818 16.715 4.667 16.8163 4.62545C16.9176 4.58391 17.0098 4.52281 17.0875 4.44566C17.1652 4.36851 17.2269 4.27681 17.2692 4.1758C17.3114 4.07479 17.3334 3.96644 17.3338 3.85694C17.3341 3.74745 17.313 3.63895 17.2714 3.53764C17.2299 3.43633 17.1688 3.34419 17.0916 3.2665L16.5 2.67483ZM4.83329 15.6665C4.33884 15.6665 3.85549 15.5199 3.44437 15.2452C3.03324 14.9705 2.71281 14.58 2.52359 14.1232C2.33437 13.6664 2.28487 13.1637 2.38133 12.6788C2.47779 12.1938 2.71589 11.7484 3.06552 11.3987C3.41516 11.0491 3.86061 10.811 4.34557 10.7145C4.83052 10.6181 5.33318 10.6676 5.79 10.8568C6.24681 11.046 6.63726 11.3664 6.91196 11.7776C7.18667 12.1887 7.33329 12.672 7.33329 13.1665C7.33329 13.8295 7.0699 14.4654 6.60106 14.9343C6.13222 15.4031 5.49633 15.6665 4.83329 15.6665Z" fill="#7985CB"/>
                                </svg>

                            </span>
                          </p>
                        </div>

                        <div class="field">
                          <label class="label has-text-primary2 font-w-500 font-14">Konfirmasi Kata Sandi<span class="has-text-danger">*</span></label>
                          <p class="control is-expanded has-icons-left">
                            <input class="input has-text-darkblue font-w-500 " type="password" placeholder="Konfirmasi Kata Sandi" name="password_confirmation" v-model="dataPassword.password_confirmation"/>
                            <span class="icon is-small is-left">
                              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" style="width: 1rem; height: 1rem;">
                                <path d="M16.5 2.67483L17.0916 2.0915C17.2485 1.93458 17.3367 1.72175 17.3367 1.49983C17.3367 1.27791 17.2485 1.06508 17.0916 0.908162C16.9347 0.751243 16.7219 0.663086 16.5 0.663086C16.278 0.663086 16.0652 0.751243 15.9083 0.908162L14.7416 2.08316L12.3833 4.4415L7.12496 9.6915C6.26332 9.12303 5.22135 8.89463 4.20093 9.05057C3.18051 9.20651 2.25431 9.73568 1.60178 10.5355C0.949253 11.3354 0.616865 12.349 0.669022 13.3799C0.721179 14.4109 1.15417 15.3858 1.88409 16.1157C2.61401 16.8456 3.58889 17.2786 4.61984 17.3308C5.65078 17.3829 6.66439 17.0505 7.46425 16.398C8.26411 15.7455 8.79328 14.8193 8.94922 13.7989C9.10515 12.7784 8.87676 11.7365 8.30829 10.8748L12.9666 6.20816L14.7333 7.98316C14.811 8.06031 14.9031 8.12141 15.0044 8.16295C15.1057 8.2045 15.2142 8.22568 15.3237 8.22529C15.4332 8.22491 15.5416 8.20296 15.6426 8.1607C15.7436 8.11844 15.8353 8.05669 15.9125 7.979C15.9896 7.9013 16.0507 7.80916 16.0922 7.70785C16.1338 7.60654 16.155 7.49804 16.1546 7.38855C16.1542 7.27905 16.1322 7.17071 16.09 7.06969C16.0477 6.96868 15.986 6.87698 15.9083 6.79983L14.1416 5.03316L15.325 3.85816L15.9083 4.4415C15.9854 4.51919 16.0771 4.58094 16.1782 4.6232C16.2792 4.66546 16.3875 4.68741 16.497 4.68779C16.6065 4.68818 16.715 4.667 16.8163 4.62545C16.9176 4.58391 17.0098 4.52281 17.0875 4.44566C17.1652 4.36851 17.2269 4.27681 17.2692 4.1758C17.3114 4.07479 17.3334 3.96644 17.3338 3.85694C17.3341 3.74745 17.313 3.63895 17.2714 3.53764C17.2299 3.43633 17.1688 3.34419 17.0916 3.2665L16.5 2.67483ZM4.83329 15.6665C4.33884 15.6665 3.85549 15.5199 3.44437 15.2452C3.03324 14.9705 2.71281 14.58 2.52359 14.1232C2.33437 13.6664 2.28487 13.1637 2.38133 12.6788C2.47779 12.1938 2.71589 11.7484 3.06552 11.3987C3.41516 11.0491 3.86061 10.811 4.34557 10.7145C4.83052 10.6181 5.33318 10.6676 5.79 10.8568C6.24681 11.046 6.63726 11.3664 6.91196 11.7776C7.18667 12.1887 7.33329 12.672 7.33329 13.1665C7.33329 13.8295 7.0699 14.4654 6.60106 14.9343C6.13222 15.4031 5.49633 15.6665 4.83329 15.6665Z" fill="#7985CB"/>
                                </svg>

                            </span>
                          </p>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="columns">
        <div class="column has-text-right">
          <button type="submit" class="button is-primary4 is-medium" :class="loading ? 'is-loading' : ''" :disabled="loading">
            Simpan
          </button>
        </div>
      </div>

    </form>

    <media-library-modal :mediaCatcher="mediaCatcher" :only_extensions="media_extensions"></media-library-modal>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import { USER, ONBOARD } from '~/consts';
import ONBOARD_MIXIN from "../mixins/onboard";

export default {
  mixins: [ONBOARD_MIXIN],

  props: {
    afterSave: {
      type: Function,
      default: null
    },
    onFailSetPassword: {
      type: Function,
      default: () => {}
    }
  },

  computed: {
    ...mapState({
      auth: state => state.auth,
      medias: state => state.medias.lists
    }),
    avatar_url() {
      if (!this.isEmpty(this.user_media) && !this.isEmpty(this.user_media.thumb_url)) {
          return this.user_media.thumb_url;
      }

      return !this.isEmpty(this.user.media) && !this.isEmpty(this.user.media.images)
         ? this.user.media.images.thumb.link : null;
    }
  },

  created() {
    Vue.nextTick(() => {
      this.user = Object.assign({}, this.auth);
    });
  },

  data() {
    return {
      tab: 0,
      loading: false,
      loading_change_password: false,
      change_password: false,
      user_media: null,
      user: {
        email: '',
        mediaId: '',
        name: '',
        gender: 'M',
        phone: '',
      },
      dataPassword: {
        password: '',
        password_confirmation: ''
      },
      media_extensions: ['png', 'jpg', 'jpeg']
    }
  },

  methods: {
    ...mapActions({
      getProfile: 'getProfile',
    }),
    ...mapMutations({
      setAuth: 'setAuth'
    }),
    async update() {
      if (this.user.setPasswordNeeded === true) {
        if (this.isEmpty(this.dataPassword.password)) {
          toast.danger('Kata sandi harus diisi');
          return;
        }

        if (this.isEmpty(this.dataPassword.password_confirmation)) {
          toast.danger('Kata sandi harus diisi');
          return;
        }

        if (this.dataPassword.password != this.dataPassword.password_confirmation) {
          toast.danger('Kata sandi tidak sesuai');
          return;
        }
      }

      if (this.isEmpty(this.user.name)) {
        toast.danger('Nama lengkap harus diisi');
        return;
      }

      if (this.isEmpty(this.user.email)) {
        toast.danger('Email harus diisi');
        return;
      }

      this.loading = true;

      let user = collect(this.user).filter((value, key) => {
        const attrs = ["name", "email", "phone", 'password', 'password_confirmation', 'confirmation_code'];

        if (attrs.indexOf(key) > -1 && !helpers.isEmpty(value) && value != 'null') {
          return true;
        }

        return false;
      }).items;
      let token = this.$cookies.get('token');

      if (this.isEmpty(this.auth.email)) {
        try {
          const { data } = await this.$axios.post(ONBOARD.UPDATE, user)
          if (data.applicationSystem.code != 0) {
            this.loading = false;
            toast.danger(data.applicationSystem.message);
            return;
          }

          token = data.data.token;
        } catch (e) {}
      }

      if (token === null) {
        await this.$store.dispatch("logout");
        return;
      }

      this.$store.commit('setToken', token);
      this.$cookies.set('token', token, {
        path: '/',
        expires: this.getDateOfTokenExpires(),
      });

      if (this.user.setPasswordNeeded === true) {
        this.setPassword();
      } else {
        if (typeof this.afterSave == 'function') {
          this.afterSave();
        }
      }

      await this.$store.dispatch("getProfile");

      this.loading = false;
    },
    setPassword() {
      const vm = this;

      this.$axios.post(USER.SET_PASSWORD, this.dataPassword).then(({ data }) => {
        if (data.applicationSystem.code == 0) {
          vm.resetData();

          if (typeof vm.afterSave == 'function') {
            vm.afterSave();
          }
        } else {
          vm.onFailSetPassword();
          this.$buefy.toast.open({
            type: 'is-danger',
            message: data.applicationSystem.message
          });
        }

        vm.loading = false;
      }).catch(() => {
        vm.loading = false;
      });
    },
    resetData() {
      const vm = this;
      vm.dataPassword.password = '';
      vm.dataPassword.password_confirmation = '';
    },
    mediaCatcher(medias) {
      const media = medias[0];

      this.user_media = media

      $('#media-library-modal').find('.delete').trigger('click');
    },
  }
}
</script>
